module.exports = __webpack_public_path__ + "static/media/WIPRO_F1.cf2844d2.txt";